module.exports = __webpack_public_path__ + "static/assets/6066ed2afb6220dcd73c8ca1b1dfe6cd.svg";